import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { GridColumnMenuPivotItem } from "./GridColumnMenuPivotItem.mjs";
import { GridColumnMenuChartsItem } from "./GridColumnMenuChartsItem.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function GridColumnMenuManagePanelItem(props) {
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(GridColumnMenuPivotItem, _extends({}, props)), /*#__PURE__*/_jsx(GridColumnMenuChartsItem, _extends({}, props))]
  });
}
export { GridColumnMenuManagePanelItem };